import type { VAxios } from '../../define/axios/Axios';
import { ExecutingJob } from '../../entities/cc/jobs.entities';

/**
 * 内容中心接口配置
 */
export const createApi = (defHttp: VAxios) => ({
  //#region 任务接口
  // 获取当前正在执行的任务列表
  getExecutingJobs: () => {
    return defHttp.get<Array<ExecutingJob>>(
      { url: `/aiad/jobs` },
      {
        preventErrorHandle: true,
      },
    );
  },
  //#endregion
});
